import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import Login from '@/views/Login.vue'
const Main = () => import('@/views/Main.vue')
const BiometricAttempts = () => import('@/views/biometric_checks/Attempts.vue')
const BiometricStats = () => import('@/views/biometric_checks/Stats.vue')

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'Main',
    component: Main,
    redirect: { name: 'BiometricAttempts' },
    children: [
      {
        path: 'biometria/intentos',
        name: 'BiometricAttempts',
        component: BiometricAttempts,
      },
      {
        path: 'biometria/estadisticas',
        name: 'BiometricStats',
        component: BiometricStats,
      },
    ],
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
  },
  {
    path: '*',
    redirect: { name: 'BiometricAttempts' }
  }
]

const router = new VueRouter({ mode: 'history', base: process.env.BASE_URL, routes })

router.beforeEach((to, from, next) => {
  if(to.name !== 'Login' && !localStorage.user){
    next({ name: 'Login' })
    return
  }
  next()
})

export default router
